import { render, staticRenderFns } from "./FrontendAngular.vue?vue&type=template&id=858c53dc&"
import script from "./FrontendAngular.vue?vue&type=script&lang=js&"
export * from "./FrontendAngular.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports